import { Injectable } from '@angular/core';
import { DateToShortDate } from '@core/util/datetime';
import { ValueToAmount } from '@core/util/money';
import { BusinessSettings } from '@models/businessSettings/settings';
import { RequisitionFields, RequisitionFieldTypes } from '@models/requisitions';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { BusinessState } from '@state/business';
import { MoneyTag } from '@state/global/tags/models/money.model';
import { CustomTags } from '@state/global/tags/tags.models';
import { TagsSelector } from '@state/global/tags/tags.selector';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class RequisitionService {
	@Select(TagsSelector.getTagInjectedDocument) parsedDocument$: Observable<
		(doc: string, tags: Partial<CustomTags>) => string
	>;
	@SelectSnapshot(BusinessState.getDefaultSettings)
	businessSettings: BusinessSettings;

	getPopulatedText(
		text: string,
		requisitionFields: RequisitionFields,
	): Observable<string> {
		const fields = Object.entries(requisitionFields ?? {}).reduce(
			(acc, [field, currentField]) => {
				let fieldValue: string | number | MoneyTag = null;

				switch (currentField.type) {
					case RequisitionFieldTypes.AMOUNT:
						fieldValue = ValueToAmount(currentField.value);
						break;
					case RequisitionFieldTypes.DATE:
						fieldValue = DateToShortDate(
							currentField.value,
							this.businessSettings.shortDateFormat,
						);
						break;
					default:
						fieldValue = currentField.value;
				}

				acc[field] = fieldValue;
				return acc;
			},
			{},
		);

		return this.parsedDocument$.pipe(
			take(1),
			map((filter) =>
				filter(text, {
					requisitions: {
						id: {
							fields,
						},
					},
				} as unknown as CustomTags),
			),
		);
	}
}
